import { RootState } from "../../store";
import { ICustomerDetails } from "./customer-details-types";

export const getCustomerDetails = (
    state: RootState
): ICustomerDetails | null => {
    return state.customerDetailsReducer.customerDetails;
};
